var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJointhecommunityLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31501 7.32242C0.43676 6.507 0 5.49767 0 4.29673C0 3.0958 0.439096 2.04205 1.31501 1.2243C2.19325 0.408876 3.32377 0 4.70887 0C6.09398 0 7.18013 0.408876 8.05604 1.2243C8.93428 2.03972 9.37104 3.06542 9.37104 4.29673C9.37104 5.52804 8.93195 6.507 8.05604 7.32242C7.17779 8.13784 6.06361 8.54672 4.70887 8.54672C3.35413 8.54672 2.19325 8.13784 1.31501 7.32242ZM8.63296 12V37H0.735742V12H8.63296Z",
    fill: "#848484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9164 14.4698C36.6379 16.3389 37.4975 18.9044 37.4975 22.1707V36.5585H29.9974V23.1847C29.9974 21.5375 29.5699 20.2571 28.7174 19.3459C27.8648 18.4347 26.7156 17.9768 25.2768 17.9768C23.838 17.9768 22.6887 18.4324 21.8362 19.3459C20.9836 20.2571 20.5562 21.5375 20.5562 23.1847V36.5585H13.0117V11.93H20.5562V15.1964C21.32 14.1076 22.3501 13.2478 23.6441 12.6146C24.9381 11.9814 26.3933 11.666 28.012 11.666C30.8943 11.666 33.1973 12.6006 34.9164 14.4674V14.4698Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointhecommunityLinkedin);
export default __webpack_public_path__ + "static/media/jointhecommunity-linkedin.d3a1783b0e31f4d1547604ec7bcbf09f.svg";
export { ForwardRef as ReactComponent };